/*
  eslint-disable
    react/button-has-type
*/

import React from 'react';
import toast, { Toaster, ToastBar } from 'react-hot-toast';
import { BsX } from 'react-icons/bs';

function SiteToaster() {
  return (
    <Toaster
      position="top-right"
      containerStyle={{ top: '90px' }}
      toastOptions={{
        duration: 5000,
        style: {
          borderRadius: '5px',
          borderLeft: '5px solid #9e0442',
          wordBreak: 'break-word',
          maxWidth: '600px',
        },
        // Default options for specific types
        success: {
          style: {
            borderLeftColor: '#3daf8d',
          },
          iconTheme: {
            primary: '#3daf8d',
          },
        },
        error: {
          duration: 15000,
          iconTheme: {
            primary: '#9e0442',
          },
        },
      }}
    >
      {(t) => (
        <ToastBar toast={t}>
          {({ icon, message }) => (
            <>
              {icon}
              {message}
              {t.type !== 'loading' && (
                <button className="btn btn-link text-gray-600 m-0 p-0" onClick={() => toast.dismiss(t.id)}>
                  <BsX style={{ fontSize: '1.5em' }} />
                </button>
              )}
            </>
          )}
        </ToastBar>
      )}
    </Toaster>
  );
}

export default SiteToaster;
